import decode from 'jwt-decode';
export default class AuthService {
    // Initializing important variables
    constructor(domain) {
      this.getUrl= this.getUrl.bind(this)
      this.login = this.login.bind(this)
    }
    getUrl(){
      var loc = window.location;
      var url = new URL(loc)
      var enviorment_url = url.hostname
      if(enviorment_url == "booking-staging.getspiffy.com"){
        return "https://staging.getspiffy.com/api/v1/"
      }
      else if(enviorment_url == "booking.getspiffy.com"){
        return "https://my.getspiffy.com/api/v1/"
      }
      else {
        return "http://localhost:3000/api/v1/"
      }
    }
    getBaseUrl(){
      var loc = window.location;
      var url = new URL(loc)
      var enviorment_url = url.hostname
      if(enviorment_url == "booking-staging.getspiffy.com"){
        return "https://staging.getspiffy.com/"
      }
      else if(enviorment_url == "booking.getspiffy.com"){
        return "https://my.getspiffy.com/"
      }
      else {
        return "http://localhost:3000/"
      }
    }
    login(username, password) {
      var prefix = this.getUrl()
      var url = prefix + "login.json"
      return fetch(url, {
        method: "POST",
        //mode: 'no-cors',
        headers: {
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'Content-Type, Authorization',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user:{
          email: username,
          password: password,
          }
        })

      })
      .then((response) => response.json())
      .then(response => {
        return response
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    merge_guest_and_logn(username, password, guest_id){
      var prefix = this.getUrl()
      var url = prefix + "merge_guest_and_login.json"
      return fetch(url, {
        method: "POST",
        //mode: 'no-cors',
        headers: {
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'Content-Type, Authorization',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user:{
            email: username,
            password: password,
          },
          guest:{
            id: guest_id
          }
        })

      })
      .then((response) => response.json())
      .then(response => {
        return response
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    switchVersions(value) {
      var prefix = this.getUrl()
      var url = prefix + "switch_consumer_web_versions.json"
      return fetch(url, {
        method: "POST",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        },
        body: JSON.stringify({
          user:{
            use_new_web: !value
          }
        })

      })
      .then((response) => response.json())
      .then(response => {
        console.log("response", response)
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    facebookLogin(email, profile, uuid) {
      var prefix = this.getUrl()
      var url = prefix + "facebook_connect.json"
      return fetch(url, {
        method: "POST",
        //mode: 'no-cors',
        headers: {
          'Access-Control-Allow-Origin':  'http://127.0.0.1:3002',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'Content-Type, Authorization',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user:{
            facebook_uid: uuid,
            facebook_profile: profile,
            email: email,
          }
        })

      })
      .then((response) => response.json())
      .then(response => {
        console.log("response", response)
        if(response.user.auth_token){
          this.setToken(response.user.auth_token) // Setting the token in localStorage
          localStorage.setItem('customer_id', response.user.id)
        }
        else {
          console.log("else")
          alert('Unable to login, please double check email and password are entered correctly.');
        }
      })
      .catch((error) => {
        console.log("catch")
        this.setState({ loginLoading: false });
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    createAccount(username, password) {
      var prefix = this.getUrl()
      var url = prefix + "register.json"
      return fetch(url, {
        method: "POST",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user:{
          email: username,
          password: password,
          }
        })

      })
      .then((response) => response.json())
      .then(response => {
          return response
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }

    logout() {
        // Clear user token and profile data from localStorage
        localStorage.removeItem('id_token');
        localStorage.removeItem('appointmentAddress')
        localStorage.removeItem('appointmentVehicles')
        localStorage.removeItem('appointmentVehicle')
        localStorage.removeItem('appointmentServices')
        localStorage.removeItem('allUpgradesArray')
        localStorage.removeItem('allUpgradesMap')
        localStorage.removeItem('appointmentUpgrades')
        localStorage.removeItem('promoAmount')
        localStorage.removeItem('apptDateTime')
        localStorage.removeItem('appointmentPackage')
        localStorage.removeItem('user')
        localStorage.removeItem('customer_id')
        localStorage.removeItem('amount')
        localStorage.removeItem('image_id')
        localStorage.removeItem('message')
        localStorage.removeItem('sendAt')
        localStorage.removeItem('name')
        localStorage.removeItem('phone')
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        return decode(this.getToken());
    }


    // fetch(url, options) {
    //     // performs api calls sending the required authentication headers
    //     const headers = {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json'
    //     }
    //
    //     // Setting Authorization header
    //     // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
    //     if (this.loggedIn()) {
    //         headers['Authorization'] = 'Bearer ' + this.getToken()
    //     }
    //
    //     return fetch(url, {
    //         headers,
    //         ...options
    //     })
    //         .then(this._checkStatus)
    //         .then(response => response.json())
    // }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/AuthService.js